// Thai translations (ภาษาไทย)
export const th = {
  // Common
  common: {
    home: 'หน้าแรก',
    settings: 'การตั้งค่า',
    language: 'ภาษา',
    loading: 'กำลังโหลด...',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    close: 'ปิด',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'การตั้งค่า',
    home: 'หน้าแรก',
    howToPlay: 'วิธีเล่น',
    pieceRules: 'กฎของตัวหมาก',
    language: 'ภาษา',
    manageSubscription: 'จัดการการสมัครสมาชิก',
    gameHistory: 'ประวัติเกม',
    analytics: 'การวิเคราะห์',
    premiumAccount: 'บัญชีพรีเมียม',
    chatEnabled: 'แชท: เปิด',
    chatDisabled: 'แชท: ปิด',
  },

  // Piece Rules
  pieceRules: {
    title: 'กฎของตัวหมาก',
    description: 'เรียนรู้การเคลื่อนที่ของตัวหมาก',
    selectPiece: 'เลือกตัวหมาก',
    selectedLabel: 'เลือกแล้ว:',
    statusLabel: 'สถานะ:',
    statusReady: 'พร้อม',
    statusViewing: 'กำลังดู',
    movement: 'การเคลื่อนที่',
    regularMovement: 'การเคลื่อนที่ปกติ',
    ability: 'ความสามารถ',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'การเคลื่อนที่',
    savage: 'ป่าเถื่อน',
    birdtype: 'ประเภทนก',
    birdType: 'ประเภทนก',
    wallBlock: 'กำแพงกีดขวาง',
    moveblocks: 'อุปสรรคการเคลื่อนที่',
    wallclimb: 'ปีนกำแพง',
    lilypad: 'ใบบัว',
    poisonous: 'มีพิษ',
    meadow: 'ทุ่งหญ้า',
    parasiticfungi: 'เชื้อราปรสิต',
    zombification: 'ซอมบี้ฟิเคชั่น',
    fungi: 'เชื้อรา',
    traverse: 'ข้ามผ่าน',
    capture: 'จับ',
    faint: 'เป็นลม',
    leap: 'กระโดด',
    swing: 'แกว่ง',
    consume: 'กิน',
    gamble: 'เสี่ยง',
    entangle: 'พัน',
    ink: 'หมึก',
    rotate: 'หัน',
    backstep: 'ถอยหลัง',
    trample: 'เหยียบ',
    charge: 'พุ่ง',
    lane: 'เลน',
    snakestrike: 'การโจมตีของงู',
    shedskin: 'ลอกคราบ',
    house: 'บ้าน',
    plant: 'ประเภทพืช',
    planttype: 'ประเภทพืช',
    capturehost: 'จับโฮสต์',
    contagion: 'การแพร่เชื้อ',
    lonewolf: 'หมาป่าโดดเดี่ยว',
    hop: 'กระโดด',
    decay: 'เน่าเปื่อย',
    slide: 'เลื่อน',
    block: 'บล็อก',
    poison: 'พิษ',
    infection: 'การติดเชื้อ',
    howl: 'หอน',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'หมีสามารถเคลื่อนที่หนึ่งช่องไปทุกทิศทาง เหมือนราชาในหมากรุก',
    bearMovementPost: 'มันถูกขวางได้เฉพาะโดยตัวหมากเพื่อน (ยกเว้นต้นไม้ หมีสามารถปีนต้นไม้ได้!)',
    bearSavage: 'หมีสามารถเอาชนะความสามารถป้องกันอย่างบล็อกแรดได้',
    bearSavagePost: 'ใช้ความป่าเถื่อน หมีสามารถจับตัวหมากใดก็ได้จากทิศทางใดก็ได้ เพิ่มความตายตัว',

    // Crane
    craneMovement: 'นกกระเรียนสามารถเคลื่อนที่ 1 หรือ 2 ช่องในเส้นตรงใดก็ได้',
    craneMovementPost: 'นกกระเรียนยังสามารถบินข้ามตัวหมากอื่นๆ ได้อีกด้วย!',
    craneBirdType: 'ตัวหมากประเภทนกไม่สามารถจับตัวหมากขนาดใหญ่หรือนักล่าได้',
    craneBirdTypePost: 'ซึ่งรวมถึงต้นไม้ แรด หมี และหมาป่า',

    // Frog
    frogMovement: 'กบกระโดด 2 ช่องในแนวทแยง',
    frogMovementPost: 'มันไม่สามารถกระโดดเพียงหนึ่งช่องได้',
    frogWallBlock: 'หากเส้นทางปกติ 2 ช่องของกบถูกบล็อกด้วยกำแพงหรือตัวหมากอื่น มันจะไม่สามารถจับได้',
    frogWallBlockPost: 'การเคลื่อนที่ปกติจะสั้นลงเหลือ 1 ช่องในแนวทแยง',
    frogWallClimb: 'เมื่อกบอยู่ที่ผนังของกระดาน (คอลัมน์ A หรือ E) มันสามารถเคลื่อนที่ขึ้นหรือลงหนึ่งช่อง',
    frogWallClimbPost: 'เว้นแต่จะถูกบล็อกโดยตัวหมากเพื่อนหรือแรดที่อยู่หน้ากบ',
    frogLilypad: 'หากกบยังไม่เคลื่อนที่ในเกม มันสามารถเคลื่อนไปยังแถวแรก 3 แถวใดก็ได้เป็นความสามารถป้องกันที่ทรงพลัง',
    frogLilypadPost: 'มันสามารถจับตัวหมากปกติใดก็ได้โดยใช้การกระโดดใบบัว ยกเว้นแรดที่อยู่ในแถวที่สูงกว่าตัวมันเอง',
    frogPoisonous: 'เมื่อสัตว์ใดจับตัวหมากกบ คุณจะเป็นพิษ!',
    frogPoisonousPost: 'ตัวหมากที่เป็นพิษจะข้ามเทิร์นถัดไปที่มีอยู่ก่อนที่จะฟื้นตัว',

    // Fungi
    fungiMovement: 'เชื้อราสามารถเคลื่อนที่หนึ่งช่องไปทุกทิศทาง',
    fungiMovementPost: 'มันถูกบล็อกได้เฉพาะโดยตัวหมากพันธมิตร',
    fungiMeadow: 'เชื้อราลดความสามารถในการเคลื่อนที่ของตัวหมากต้นไม้ฝ่ายตรงข้าม',
    fungiMeadowPost: 'ตัวหมากต้นไม้ฝ่ายตรงข้ามไม่สามารถเคลื่อนที่ภายใน 1 ช่องจากตัวหมากเชื้อรา',
    fungiParasitic: 'เชื้อราสามารถทำให้ตัวหมากต้นไม้ฝ่ายตรงข้ามไม่สามารถเคลื่อนที่ได้',
    fungiParasiticPost: 'หากเชื้อราอยู่ภายใน 1 ช่องจากต้นไม้ฝ่ายตรงข้าม มันจะไม่สามารถเคลื่อนที่ได้จนกว่าเชื้อราจะเคลื่อนออกไปหรือถูกจับ',
    fungiZombification: 'เชื้อราสามารถทำให้ตัวหมากสัตว์ฝ่ายตรงข้ามที่จับมันกลายเป็นซอมบี้ ทำให้สามารถควบคุมสัตว์ฝ่ายตรงข้ามได้หนึ่งเทิร์น',
    fungiZombificationPost: 'ตัวหมากที่ถูกทำให้เป็นซอมบี้ยังถือว่าเป็นตัวหมากเชื้อราในเทิร์นนั้น แม้ว่าเชื้อราจะเป็นราชาของคุณ เกมก็ไม่สิ้นสุดจนกว่าหลังจากเทิร์นนั้น',
    fungiFungi: 'เห็ด',
    fungiFungiPost: 'เช่นพิษ การพัน และการติดเชื้อไวรัส แต่ไม่ใช่การทำให้เป็นซอมบี้เพราะมันสามารถทำให้คนอื่นเป็นซอมบี้ได้!',

    // Goat
    goatMovement: 'แพะสามารถเคลื่อนที่หนึ่งช่องไปทุกทิศทาง',
    goatMovementPost: 'แพะเคลื่อนที่ช้า แต่มีความสามารถที่ทรงพลัง',
    goatTraverse: 'แพะสามารถข้ามผ่านตัวหมากอื่นๆ ที่เชื่อมต่อกันเพื่อสร้างศักยภาพการเคลื่อนที่ที่มหาศาล',
    goatTraversePost: 'แพะไม่สามารถข้ามผ่านแพะที่เป็นลมหรือตัวหมากเล็กๆ เช่นไวรัส',
    goatCapture: 'แพะไม่สามารถจับนักล่าใดๆ ได้',
    goatCapturePost: 'เช่น หมีหรือหมาป่า',
    goatFaint: 'แพะสามารถเป็นลมเพื่อหลีกเลี่ยงการจับ ยกเว้นจากตัวหมากขนาดใหญ่เช่นต้นไม้และแรด',
    goatFaintPost: 'ขณะเป็นลม ฝ่ายตรงข้ามสามารถ \'ยืน\' บนแพะที่เป็นลมเพื่อหยุดการเคลื่อนที่ของมัน',

    // Monkey
    monkeyMovement: 'ลิงสามารถเคลื่อนที่หนึ่งช่องไปทุกทิศทาง',
    monkeyMovementPost: 'หากไม่มีตัวหมากอื่นๆ ให้ใช้ ลิงจะมีการเคลื่อนที่จำกัด',
    monkeyLeap: 'ลิง เหมือนเกมหมากฮอส สามารถกระโดดข้ามตัวหมากอื่นๆ ในแนวเส้นตรงเพื่อศักยภาพการเคลื่อนที่ที่มหาศาล',
    monkeyLeapPost: 'แต่หากกระโดดข้ามตัวหมากศัตรู ลิงต้องทอยลูกเต้าเพื่อรอดชีวิต โอกาส 1/6 ที่จะถูกจับสำหรับศัตรูแต่ละตัวที่กระโดดข้าม!',
    monkeySwing: 'หากลิงใช้การกระโดดข้ามต้นไม้ ลิงจะได้รับเทิร์นโบนัส',
    monkeySwingPost: 'การใช้การแกว่งต้นไม้สร้างคอมโบ synergy ที่ทรงพลังระหว่างลิงและตัวหมากต้นไม้',
    monkeyConsume: 'ลิงสามารถกินตัวหมากเชื้อราเพื่อรับเทิร์นโบนัส',
    monkeyConsumePost: 'นำไปสู่การผสมผสานที่ทำลายล้างเมื่อรวมกับเทิร์นโบนัสอื่นๆ',
    monkeyGamble: 'นอกจากการทอยลูกเต้าเพื่อกระโดดข้ามศัตรูแล้ว ลิงต้องเสี่ยงเพื่อจับหมี',
    monkeyGamblePost: 'ลิงต้องทอยได้ 5 หรือ 6 บนลูกเต้า 6 ด้านเพื่อจับหมี ไม่เช่นนั้นมันจะถูกจับเอง',

    // Octopus
    octopusMovement: 'ปลาหมึกเคลื่อนที่หนึ่งช่องไปทุกทิศทาง',
    octopusCapture: 'ปลาหมึกสามารถจับได้เฉพาะในแนวตั้งฉาก',
    octopusCapturePost: 'ปลาหมึกสามารถจับหรือพันตัวหมากในรูปแบบที่ซับซ้อน ดังนั้นควรตรวจสอบการจับสีแดงและการพันสีม่วงเสมอ!',
    octopusEntangle: 'ปลาหมึกสามารถพันตัวหมากศัตรูที่อยู่ติดกัน ทำให้ไม่สามารถเคลื่อนที่ได้ มันยังสามารถเคลื่อนที่หนึ่งช่องและพันศัตรูได้อีกด้วย!',
    octopusEntanglePost: 'ตัวหมากที่ถูกพันไม่สามารถเคลื่อนที่ได้จนกว่าปลาหมึกจะเคลื่อนออกไปหรือถูกจับ',
    octopusInk: 'ปลาหมึกสามารถใช้หมึกเพื่อหลบหนีจากสถานการณ์อันตราย สร้างเงาได้ถึง 3 ตัว',
    octopusInkPost: 'สับสนศัตรูและอนุญาตให้เล่นล่อและหลบหลีกที่น่าสนใจ',

    // Penguin
    penguinMovement: 'เพนกวินเลื่อนไปในเส้นตรงตามทิศทางที่กำหนดจนกว่ากำแพงหรือตัวหมากจะขวางการเคลื่อนที่',
    penguinMovementPost: 'หลังจากเคลื่อนที่ เพนกวินสามารถตั้งทิศทางสุดท้ายของมันได้ในเทิร์นเดียวกันด้วย',
    penguinRotate: 'ที่จุดเริ่มต้นของการแข่งขัน เพนกวินจะหันลง และต้องหมุนก่อนจึงจะสามารถเลื่อนได้ เรียกอีกอย่างว่ากำลังนอน',
    penguinRotatePost: 'เพนกวินในตำแหน่งใดก็ได้สามารถเลือกที่จะหมุนแทนการเคลื่อนที่',
    penguinBirdType: 'เพนกวินมีความสามารถในการจับจำกัด เช่นเดียวกับนกกระเรียน มันไม่สามารถจับตัวหมากขนาดใหญ่หรือนักล่าเช่นต้นไม้ แรด หมี หรือหมาป่า',
    penguinBirdTypePost: 'หลังจากจับ เพนกวินสามารถหมุนเพื่อหันหน้าไปทิศทางใดก็ได้เพื่อการวางตำแหน่งเชิงกลยุทธ์',

    // Rhino
    rhinoMovement: 'แรดเคลื่อนที่สองช่องไปข้างหน้าเท่านั้น',
    rhinoMovementPost: 'มันไม่สามารถเคลื่อนที่เพียง 1 ช่อง',
    rhinoBackStep: 'แรดสามารถเคลื่อนที่หลัง-ซ้ายหรือหลัง-ขวา',
    rhinoCharge: 'แรดสามารถเดินทางเพิ่มหนึ่งช่องไปข้างหน้าได้หนึ่งครั้งต่อเกมโดยใช้ความสามารถพุ่ง',
    rhinoChargePost: 'นำไปสู่ศักยภาพการเคลื่อนที่และการจับที่ทำลายล้าง',
    rhinoTrample: 'แรดจับตัวหมากทั้งหมดในเส้นทางการเดินทางด้วยการเหยียบ',
    rhinoTramplePost: 'รวมถึงตัวหมากแพะที่เป็นลม',
    rhinoLane: 'แรดสามารถสลับสถานที่กับตัวหมากพันธมิตรอื่นได้ ทำให้เกิดการเล่นเลนเชิงกลยุทธ์',
    rhinoLanePost: 'แต่เฉพาะถ้าแรดและตัวหมากพันธมิตรทั้งสองยังไม่ได้เคลื่อนที่',

    // Snake
    snakeMovement: 'งูสามารถเคลื่อนที่ 2 ช่องในเส้นตรงใดก็ได้',
    snakeMovementPost: 'งูเคลื่อนที่พอดี 2 ช่อง เว้นแต่จะถูกบล็อกด้วยกำแพงหรือตัวหมากเพื่อน',
    snakeMoveBlocks: 'เมื่อถูกบล็อกด้วยกำแพงหรือตัวหมากที่ไม่สามารถจับได้ การเคลื่อนที่ของงูจะสั้นลงเหลือ 1 ช่อง',
    snakeMoveBlocksPost: 'มันยังสามารถเคลื่อนที่สองช่องได้แม้ว่าจะมีตัวหมากกลางทาง',
    snakeStrike: 'งูสามารถโจมตี 3 ช่องไปข้างหน้าหากมีสัตว์ศัตรู',
    snakeStrikePost: 'ตราบใดที่ไม่มีตัวหมากกลางทางขวางเส้นทาง',
    snakeShedskin: 'หนึ่งครั้งต่อเกม งูสามารถลอกคราบและกลับไปยังแถวแรกหากช่องนั้นว่าง',
    snakeShedskinPost: 'การเกิดใหม่นี้ให้งูมีชีวิตเพิ่มในแต่ละเกม',

    // Tree
    treeMovement: 'ต้นไม้สามารถเคลื่อนที่หนึ่งช่องไปข้างหน้าหรือไปยังช่องใดก็ได้บนแถวของมันจากด้านหนึ่งไปอีกด้านหนึ่ง',
    treeMovementPost: 'ตราบใดที่เส้นทางของมันไม่ถูกบล็อก',
    treeHouse: 'ต้นไม้สามารถให้ที่พักอาศัยแก่ตัวหมากอื่น ปกป้องพวกมันจากศัตรูที่ไม่สามารถปีนต้นไม้ได้ บางทีตัวหมากสามารถปีนเช่น หมี นกกระเรียน กบ เชื้อรา แพะ ลิง ปลาหมึก และงู',
    treeHousePost: 'เมื่อตัวหมากที่สามารถปีนต้นไม้โจมตี มันจะจับเฉพาะตัวหมากที่อยู่อาศัย ปกป้องต้นไม้',
    treeTrample: 'ต้นไม้เหมือนแรด จับตัวหมากทั้งหมดในช่องเมื่อมันเคลื่อนที่',
    treeTramplePost: 'นี่รวมถึงแพะที่เป็นลม',
    treePlant: 'ต้นไม้เป็นพืช ไม่ใช่สัตว์ ดังนั้นจึงมีภูมิคุ้มกันต่อผลกระทบหลายอย่าง',
    treePlantPost: 'เช่นพิษ การทำให้เป็นซอมบี้ การพัน และการติดเชื้อไวรัส!',

    // Virus
    virusMovement: 'ไวรัสสามารถเคลื่อนที่ไปยังช่องที่มีสัตว์อยู่เท่านั้น ซึ่งอยู่ห่างสองช่อง',
    virusMoveBlocks: 'ไวรัสสามารถเคลื่อนที่เพียงหนึ่งช่องหากมันอยู่ติดกับกำแพง',
    virusCaptureHost: 'เมื่อไวรัสลงจอดบน(ใน)ตัวหมากสัตว์ใดก็ได้ มันเพียงแค่ติดเชื้อพวกมัน พวกมันยังสามารถเล่นต่อได้ตามปกติในขณะที่ติดเชื้อ',
    virusCaptureHostPost: 'ไวรัสจับตัวหมากเฉพาะเมื่อมันออกจากโฮสต์ที่ติดเชื้อ',
    virusContagion: 'ไวรัสสามารถแพร่กระจายอย่างรวดเร็วโดยติดเชื้อโฮสต์หลายตัวในเทิร์นเดียว',
    virusContagionPost: 'การแพร่เชื้อช่วยให้ไวรัสทำการเคลื่อนที่ที่ถูกต้องได้มากเท่าที่ต้องการในแต่ละเทิร์น',

    // Wolf
    wolfMovement: 'หมาป่าสามารถเคลื่อนที่ในรูปตัว L เหมือนม้าในหมากรุก',
    wolfMovementPost: 'มันไม่ถูกขวางโดยตัวหมากอื่นๆ',
    wolfLoneWolf: 'หมาป่า',
    wolfLoneWolfPost: 'หมาป่ายังถือว่าตัวเองโดดเดี่ยวเมื่อมันยังมีแพะที่เป็นลมหรือพันธมิตรไวรัส',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 ลากเพื่อสำรวจ • บีบเพื่อซูม',
    dragToExploreDesktop: '🖱️ ลากเพื่อสำรวจ • เลื่อนเพื่อซูม',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'ย้อนกลับ',
    next: 'ถัดไป',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'แซนด์บ็อกซ์',
    description: 'ทดลองและฝึกฝน',
    mode: 'โหมด:',
    modeValue: 'แซนด์บ็อกซ์',
    status: 'สถานะ:',
    statusReady: 'พร้อม',
    clearBoard: 'ล้างกระดาน',
  },

  // Multiplayer
  multiplayer: {
    title: 'ผู้เล่นหลายคน',
    description: 'หาการแข่งขันของคุณและแข่งขันกัน!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'การแข่งขันจัดอันดับ',
    matchProgress: 'ความคืบหน้าการแข่งขัน',
    gamesCompleted: '{games} / 10 เกมเสร็จสมบูรณ์',
    estimatedFinalRating: 'คะแนนสุดท้ายโดยประมาณ',
    startingRating: 'คะแนนเริ่มต้น',
    matchesRemaining: 'เหลืออีก {matches} การแข่งขัน',
    findPlacementMatch: 'หาการแข่งขันจัดอันดับ',

    // Matchmaking modes
    findMatch: 'หาการแข่งขัน',
    competitive: 'การแข่งขัน',
    competitiveDesc: 'หาคู่ต่อสู้ใกล้เคียงอันดับของคุณ',
    quick: 'รวดเร็ว',
    quickDesc: 'หาการแข่งขันแบบแข่งขันอย่างรวดเร็ว',
    casual: 'สบายๆ',
    casualDesc: 'ไม่มีอันดับ - เล่นเพื่อความสนุก!',
    placement: 'การจัดอันดับ',
    placementDesc: 'เล่น 10 แมตช์เพื่อรับอันดับ',
    startSearch: 'เริ่มค้นหา',

    // Searching
    searching: 'กำลังค้นหา...',
    mode: 'โหมด:',
    inQueue: 'ในคิว:',
    players: 'ผู้เล่น',
    playersPlural: 'ผู้เล่น',
    cancelSearch: 'ยกเลิกการค้นหา',

    // Game info
    status: 'สถานะ:',
    ready: 'พร้อม',
    selectingKing: 'กำลังเลือกราชา',
    placingPieces: 'กำลังวางตัวหมาก',
    playing: 'กำลังเล่น',
    gameType: 'ประเภทเกม:',
    opponent: 'คู่ต่อสู้:',
    opponentElo: 'ELO ของคู่ต่อสู้:',
    unranked: 'ไม่มีอันดับ',

    // Piece placement
    dragPieces: 'ลากตัวหมากไปยังกระดาน',
    lightPieces: 'ตัวหมากสว่าง (คุณ)',
    darkPieces: 'ตัวหมากมืด (คุณ)',

    // Waiting states
    waitingForOpponent: 'กำลังรอคู่ต่อสู้...',
    waitingForKing: 'กำลังรอคู่ต่อสู้เลือกราชาของพวกเขา...',

    // Warnings
    invalidPlacement: 'การวางไม่ถูกต้อง',
    lightTurn: 'ถึงเทิร์นของผู้เล่นสว่าง!',
    darkTurn: 'ถึงเทิร์นของผู้เล่นมืด!',
    onlyLightPieces: 'คุณสามารถวางตัวหมากสว่างได้เท่านั้น!',
    onlyDarkPieces: 'คุณสามารถวางตัวหมากมืดได้เท่านั้น!',
    mustPlaceOnRow: 'ตัวหมาก{color}ต้องถูกวางบนแถว {row}!',

    // Chat
    chat: 'แชท',
    typeMessage: 'พิมพ์ข้อความ...',
    send: 'ส่ง',
  },

  // Main Page
  mainPage: {
    title: 'หมากรุกสัตว์',
    subtitle: 'เกมสำหรับมนุษย์',
    playersOnline: 'ผู้เล่นออนไลน์ในขณะนี้',
    placement: 'การจัดอันดับ',
    placementProgress: 'การจัดอันดับ',
    challengeAI: 'ท้าทาย AI',
    multiplayer: 'ผู้เล่นหลายคน',
    sandbox: 'แซนด์บ็อกซ์',
    tutorials: 'บทเรียน',
    shop: 'ร้านค้า',
    collection: 'คอลเลกชัน',
    history: 'ประวัติ',
    analytics: 'การวิเคราะห์',
    courses: 'หลักสูตร',
    upgradeAccount: 'อัปเกรดบัญชี',
    signIn: 'ลงชื่อเข้าใช้',
    playAsGuest: 'เล่นในฐานะแขก',
    welcomeBack: 'ยินดีต้อนรับกลับมา! คุณมักจะเล่นในฐานะ',

    // Learn the Pieces section
    learnThePieces: 'เรียนรู้ตัวหมาก',

    // Learn the Rules section
    learnTheRules: 'เรียนรู้กฎ',
    premiseTitle: 'หลักการ',
    premiseText: 'Zodiac เป็นทางเลือกอื่นของหมากรุกที่มีราชาที่ซ่อนอยู่จากรายชื่อ 13 ตัว เลือกรายชื่อที่ไม่ซ้ำใคร จากนั้นหลอกคู่ต่อสู้ของคุณเพื่อเอาชนะพวกเขาบนกระดาน 5 คูณ 8',
    selectionTitle: 'การเลือก',
    selectionText: 'เพื่อเริ่มเกม เลือกราชาของคุณอย่างลับๆ จากนั้นวางตัวหมาก 5 ตัวของคุณสลับกับคู่ต่อสู้ของคุณเพื่อสร้างหนึ่งในสถานะเริ่มต้นมากกว่า 500 พันล้าน',
    objectiveTitle: 'วัตถุประสงค์',
    objectiveText: 'ไม่ว่าจะอ่านคู่ต่อสู้ของคุณเพื่อจับราชาลับของพวกเขา หรือแข่งราชาของคุณข้ามกระดานเพื่อรับชัยชนะที่แน่นอน!',
    competeTitle: 'แข่งขัน',
    competeText: 'ทดสอบทักษะของคุณบนบันไดอันดับ พัฒนาเทคนิคและกลยุทธ์ส่วนบุคคลใหม่ๆ เพิ่มอันดับเพื่อเผชิญหน้ากับคนที่ดีที่สุด!',
    fullRulesButton: 'สำหรับกฎอย่างเป็นทางการทั้งหมด คลิกที่นี่',

    // FAQ section
    faqTitle: 'คำถามที่พบบ่อย',
    faqQuestion1: 'แนวคิดเบื้องหลังหมากรุก Zodiac คืออะไร?',
    faqAnswer1: 'หมากรุก Zodiac ได้รับแรงบันดาลใจในตอนแรกจากคำพูดของ Bobby Fischer เกี่ยวกับแรงบันดาลใจของเขาในการสร้าง Chess960 เราต้องการขยายความคิดในการต่อสู้กับการท่องจำแบบท่องจำและเฉลิมฉลองสัญชาตญาณของมนุษย์ในความลึกที่ไม่อาจคาดเดาได้!',
    faqQuestion2: 'ทำไมเราถึงต้องการทางเลือกอื่นของหมากรุก',
    faqAnswer2: 'เราไม่ต้องการ! Zodiac ไม่ต้องการทำให้ผู้คนเลิกเล่นหมากรุก! มันเป็นตัวเลือกที่แตกต่างกันด้วยจุดแข็งและจุดอ่อนของตัวเอง เราหวังว่าคุณจะสนุกกับมันและช่วยเราปรับเกมนี้เพื่อทำให้การเล่นใหม่มีชีวิตชีวา',
    faqQuestion3: 'คุณจะชนะในหมากรุก Zodiac ได้อย่างไร?',
    faqAnswer3: 'มีสามวิธีในการชนะ: จับตัวหมากราชาที่ซ่อนอยู่ของคู่ต่อสู้ คุณ แข่งราชาของคุณเองไปยังอีกด้านของกระดาน หรือในการแข่งขันที่มีการควบคุมเวลา ให้เวลาของคู่ต่อสู้คุณหมด',
    faqQuestion4: 'นี่คือ FAQ หรือไม่?',
    faqAnswer4: 'ใช่ คุณสามารถดูคำถามใดๆ ที่ระบุไว้ใน FAQ และหากคุณต้องการรายละเอียดเพิ่มเติม คุณสามารถคลิกที่คำถามแล้วอ่านรายละเอียดต่อไปนี้ เช่นรายละเอียดเหล่านี้ที่คุณกำลังอ่านอยู่ตอนนี้',
    faqQuestion5: 'เกมทั่วไปใช้เวลานานแค่ไหน?',
    faqAnswer5: 'แต่ละเกมแตกต่างกันอย่างมาก! บางเกมจบใน 2 ตา และบางเกมอาจใช้เวลา 30 นาที โดยทั่วไปเรามักพบว่าอยู่ที่ 5-15 นาที!',
    faqQuestion6: 'จะเกิดอะไรขึ้นถ้าไม่มีใครสามารถทำการเคลื่อนที่ที่ถูกต้องได้?',
    faqAnswer6: 'หากผู้เล่นไม่สามารถทำการเคลื่อนที่ที่ถูกต้องใดๆ (สเตลเมท) เกมจะจบลงด้วยการเสมอ เกมยังสามารถจบลงด้วยการเสมอผ่านการทำซ้ำ (สถานะกระดานเดียวกัน 3 ครั้ง) หรือโดยข้อตกลงร่วมกันระหว่างผู้เล่น!',

    // About section
    aboutButton: 'เกี่ยวกับ',
    privacyPolicy: 'นโยบายความเป็นส่วนตัว',
    developerInterface: 'อินเทอร์เฟซนักพัฒนา',
  },

  // About Modal
  about: {
    title: 'เกี่ยวกับ Zodiac',
    paragraph1: 'Zodiac เป็นเกมกระดานที่คล้ายกับหมากรุกที่รวมองค์ประกอบของการเลือกตัวหมากจากเกมเช่น LoL และ DotA พร้อมกับกลไกการหลอกลวงจากโป๊กเกอร์หรือเกมอนุมานทางสังคม',
    paragraph2: 'เวอร์ชันแรกของเกมถูกสร้างขึ้นในปี 2014 ภายใต้ชื่อ Shadow Chess ในปี 2018 มันถูกออกแบบใหม่เพื่อเป็นสิ่งที่คุณเห็นในวันนี้ มีรายชื่อตัวหมากที่สนุกสนานพร้อมรูปแบบการเคลื่อนที่และความสามารถที่สมดุลแต่ไม่ซ้ำใคร',
    paragraph3: 'วิสัยทัศน์ของเราคือการบันทึกข้อมูลการเล่นเกมของผู้ใช้ทั้งหมดเพื่อพัฒนาเกมต่อไปในความพยายามที่จะรักษาเกมเพลย์ให้สดใหม่ ส่งเสริมการเล่นที่แปลกใหม่',
    paragraph4: 'ด้วยพื้นที่ค้นหาขนาดยักษ์ของ Zodiac ข้อมูลที่ซ่อนอยู่ และตำแหน่งกระดานเปิด เราหวังว่าจะยับยั้งการครอบงำของ AI และรักษา zodiac ให้เป็นเกมสำหรับมนุษย์!',
  },

  // Privacy Policy
  privacy: {
    title: 'นโยบายความเป็นส่วนตัว',
    lastUpdated: 'อัปเดตล่าสุด',

    introduction: {
      title: 'บทนำ',
      p1: 'ยินดีต้อนรับสู่ Zodiac Chess ("เรา" "ของเรา" หรือ "เรา") เรามุ่งมั่นที่จะปกป้องความเป็นส่วนตัวของคุณและให้แน่ใจว่าคุณมีประสบการณ์การเล่นเกมที่ปลอดภัยและสนุกสนาน นโยบายความเป็นส่วนตัวนี้อธิบายว่าเราเก็บรวบรวม ใช้ เปิดเผย และปกป้องข้อมูลของคุณอย่างไรเมื่อคุณใช้เว็บไซต์และเกมของเรา',
      p2: 'การใช้ Zodiac Chess คุณยอมรับการรวบรวมและการใช้ข้อมูลตามนโยบายนี้ หากคุณไม่เห็นด้วยกับนโยบายและแนวปฏิบัติของเรา โปรดอย่าใช้บริการของเรา',
      contact: 'ติดต่อเราที่:',
    },

    infoCollect: {
      title: 'ข้อมูลที่เรารวบรวม',
      accountInfo: {
        title: '1. ข้อมูลบัญชี',
        item1: 'ที่อยู่อีเมล: จำเป็นสำหรับการสร้างบัญชีและการสื่อสาร',
        item2: 'ชื่อผู้ใช้: ชื่อแสดงที่คุณเลือก',
        item3: 'รหัสผ่าน: เข้ารหัสและเก็บอย่างปลอดภัย',
      },
      gameData: {
        title: '2. ข้อมูลเกม',
        item1: 'สถิติเกม: ชนะ แพ้ คะแนน ELO ความคืบหน้าการแข่งขันจัดอันดับ',
        item2: 'ข้อมูลการเล่นเกม: การเลือกตัวหมาก การเคลื่อนที่ที่ทำ กลยุทธ์ที่ใช้',
        item3: 'ประวัติการแข่งขัน: บันทึกของเกมที่เล่น คู่ต่อสู้ที่เผชิญ',
        item4: 'การซื้อในเกม: ไอเทมเครื่องสำอางและสถานะสมาชิกพรีเมียม',
      },
      technicalData: {
        title: '3. ข้อมูลทางเทคนิค',
        item1: 'ข้อมูลอุปกรณ์: ประเภทเบราว์เซอร์ ระบบปฏิบัติการ',
        item2: 'ข้อมูลการใช้งาน: หน้าที่เยี่ยมชม เวลาที่ใช้ คุณสมบัติที่ใช้',
        item3: 'พื้นที่เก็บข้อมูลในเครื่อง: การตั้งค่าภาษา การตั้งค่า UI สถานะเกมชั่วคราว',
      },
    },

    children: {
      title: 'ความเป็นส่วนตัวของเด็ก (การปฏิบัติตาม COPPA)',
      p1: 'Zodiac Chess ได้รับการออกแบบให้เหมาะกับครอบครัวและเหมาะสมสำหรับผู้เล่นทุกวัย รวมถึงเด็ก เราใส่ใจเป็นพิเศษในการปฏิบัติตาม Children\'s Online Privacy Protection Act (COPPA)',
      p2: 'สำหรับผู้ใช้อายุต่ำกว่า 13 ปี: เราแนะนำให้เด็กใช้โหมดเล่นแขกของเรา ซึ่งไม่ต้องสร้างบัญชีหรือรวบรวมข้อมูล บัญชีแขกไม่มีการเข้าถึงคุณสมบัติแชทข้อความ ทำให้แน่ใจว่าเด็กไม่ได้สัมผัสกับการสื่อสารกับอินเทอร์เน็ตที่กว้างขึ้น หากเด็กสร้างบัญชี เราต้องการความยินยอมของผู้ปกครองก่อนรวบรวมข้อมูลส่วนบุคคลใดๆ',
      p3: 'เราไม่รวบรวม ใช้ หรือแชร์ข้อมูลส่วนบุคคลจากเด็กอายุต่ำกว่า 13 ปีโดยเจตนาโดยไม่ได้รับความยินยอมจากผู้ปกครองที่ผ่านการตรวจสอบ',
      p4: 'ความปลอดภัยในการแชท: แชทข้อความถูกปิดใช้งานโดยอัตโนมัติสำหรับบัญชีแขก/ชั่วคราวทั้งหมด ผู้ถือบัญชีมาตรฐานมีตัวเลือกในการปิดใช้งานฟังก์ชันแชทในการตั้งค่าบัญชีของตนได้ตลอดเวลา',
      parentalRights: 'ผู้ปกครองมีสิทธิ์:',
      right1: 'ตรวจสอบข้อมูลส่วนบุคคลของบุตรหลานของพวกเขา',
      right2: 'ขอลบข้อมูลของบุตรหลานของพวกเขา',
      right3: 'ปฏิเสธการรวบรวมหรือการใช้ข้อมูลของบุตรหลานของพวกเขาต่อไป',
      contactUs: 'หากต้องการใช้สิทธิ์เหล่านี้หรือหากคุณเชื่อว่าบุตรหลานของคุณได้ให้ข้อมูลส่วนบุคคลแก่เรา โปรดติดต่อเราทันทีที่ contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'วิธีที่เราใช้ข้อมูลของคุณ',
      item1: 'ให้บริการและปรับปรุงบริการเกมของเรา',
      item2: 'จับคู่คุณกับคู่ต่อสู้ที่เหมาะสมตามระดับทักษะ',
      item3: 'ติดตามความคืบหน้า สถิติ และความสำเร็จของคุณ',
      item4: 'ดำเนินการชำระเงินสำหรับสมาชิกพรีเมียมและไอเทมเครื่องสำอาง',
      item5: 'ส่งประกาศบริการที่สำคัญและการอัปเดต',
      item6: 'วิเคราะห์ข้อมูลการเล่นเกมเพื่อปรับปรุงความสมดุลของเกมและคุณสมบัติ',
    },

    thirdParty: {
      title: 'บริการของบุคคลที่สาม',
      firebase: {
        title: 'Firebase (Google)',
        description: 'เราใช้ Firebase สำหรับการตรวจสอบสิทธิ์ การจัดเก็บฐานข้อมูล และฟังก์ชันผู้เล่นหลายคน Firebase อาจรวบรวมข้อมูลบางอย่างตามที่อธิบายไว้ในนโยบายความเป็นส่วนตัวของพวกเขา',
      },
      stripe: {
        title: 'Stripe',
        description: 'เราใช้ Stripe เพื่อดำเนินการชำระเงินสำหรับสมาชิกพรีเมียมและการซื้อในแอป Stripe จัดการข้อมูลบัตรชำระเงินทั้งหมด - เราไม่เคยเห็นหรือจัดเก็บรายละเอียดการชำระเงินทั้งหมดของคุณ',
      },
      netlify: {
        title: 'Netlify',
        description: 'เว็บไซต์ของเราโฮสต์บน Netlify ซึ่งอาจรวบรวมข้อมูลการโฮสต์เว็บมาตรฐานเช่นที่อยู่ IP และบันทึกการเข้าถึง',
      },
      adsense: {
        title: 'Google AdSense (อนาคต)',
        description: 'เราอาจแสดงโฆษณาผ่าน Google AdSense โฆษณาเหล่านี้อาจใช้คุกกี้เพื่อการปรับแต่งในแบบของคุณ สำหรับเนื้อหาที่มุ่งเป้าไปยังเด็ก เราจะแสดงโฆษณาที่ไม่ได้ปรับแต่งในแบบของคุณเท่านั้นตาม COPPA',
      },
      viewPolicy: 'ดูนโยบายความเป็นส่วนตัวของพวกเขา',
    },

    cookies: {
      title: 'คุกกี้และพื้นที่เก็บข้อมูลในเครื่อง',
      description: 'เราใช้พื้นที่เก็บข้อมูลในเครื่องของเบราว์เซอร์ (คล้ายกับคุกกี้) เพื่อปรับปรุงประสบการณ์ของคุณ:',
      item1: 'การตั้งค่าภาษา: จดจำภาษาที่คุณเลือก',
      item2: 'เซสชันบัญชี: เก็บคุณเข้าสู่ระบบ (ทำงานกับ Firebase)',
      item3: 'การตั้งค่าเกม: จดจำการตั้งค่า UI และการตั้งค่าแซนด์บ็อกซ์ของคุณ',
      item4: 'คุกกี้โฆษณา: หากคุณยินยอม บริการโฆษณาของบุคคลที่สามอาจใช้คุกกี้เพื่อการปรับแต่งโฆษณา',
    },

    security: {
      title: 'ความปลอดภัยของข้อมูล',
      p1: 'เราใช้มาตรการรักษาความปลอดภัยที่เหมาะสมเพื่อปกป้องข้อมูลของคุณ:',
      item1: 'การเข้ารหัสรหัสผ่าน: รหัสผ่านทั้งหมดถูกเข้ารหัสโดยใช้วิธีมาตรฐานอุตสาหกรรม',
      item2: 'การเชื่อมต่อที่ปลอดภัย: การเข้ารหัส HTTPS สำหรับการส่งข้อมูลทั้งหมด',
      item3: 'กฎความปลอดภัย Firebase: การควบคุมการเข้าถึงฐานข้อมูลที่เข้มงวด',
      p2: 'อย่างไรก็ตาม ไม่มีวิธีการส่งผ่านอินเทอร์เน็ตที่ปลอดภัย 100% แม้ว่าเราจะพยายามปกป้องข้อมูลของคุณ เราไม่สามารถรับประกันความปลอดภัยสมบูรณ์',
    },

    retention: {
      title: 'การเก็บรักษาข้อมูล',
      p1: 'เราเก็บรักษาข้อมูลของคุณดังนี้:',
      item1: 'บัญชีที่ใช้งานอยู่: ข้อมูลจะถูกเก็บรักษาในขณะที่บัญชีของคุณใช้งานอยู่',
      item2: 'บัญชีที่ไม่ได้ใช้งาน: หากบัญชีของคุณไม่ได้ใช้งานเป็นเวลา 10 ปี เราอาจลบข้อมูลของคุณ',
    },

    rights: {
      title: 'สิทธิ์ความเป็นส่วนตัวของคุณ',
      description: 'ขึ้นอยู่กับสถานที่ของคุณ คุณอาจมีสิทธิ์ต่อไปนี้:',
      access: {
        title: 'การเข้าถึง:',
        description: 'ขอสำเนาข้อมูลส่วนบุคคลของคุณ',
      },
      correction: {
        title: 'การแก้ไข:',
        description: 'ขอการแก้ไขข้อมูลของคุณ',
      },
      deletion: {
        title: 'การลบ:',
        description: 'ขอการลบบัญชีและข้อมูลของคุณ',
      },
      portability: {
        title: 'การพกพาข้อมูล:',
        description: 'ขอข้อมูลของคุณในรูปแบบที่พกพาได้',
      },
      optOut: {
        title: 'เลือกไม่รับ:',
        description: 'เลือกไม่รับการสื่อสารทางการตลาด',
      },
      contact: 'หากต้องการใช้สิทธิ์ใดๆ เหล่านี้ โปรดติดต่อเราที่ contact@zodiac-chess.com',
    },

    international: {
      title: 'ผู้ใช้ระหว่างประเทศ',
      p1: 'Zodiac Chess ดำเนินการจากนิวซีแลนด์ หากคุณเข้าถึงบริการของเราจากนอกนิวซีแลนด์ โปรดทราบว่าข้อมูลของคุณอาจถูกโอน จัดเก็บ และประมวลผลในนิวซีแลนด์และประเทศอื่นๆ ที่ผู้ให้บริการของเราดำเนินการ',
      p2: 'การใช้บริการของเรา คุณยินยอมให้โอนข้อมูลของคุณไปยังประเทศนอกประเทศที่คุณอาศัยอยู่ ซึ่งอาจมีกฎหมายคุ้มครองข้อมูลที่แตกต่างกัน',
    },

    changes: {
      title: 'การเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้',
      description: 'เราอาจอัปเดตนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว เราจะแจ้งให้คุณทราบเกี่ยวกับการเปลี่ยนแปลงใดๆ โดยการโพสต์นโยบายความเป็นส่วนตัวใหม่บนหน้านี้และอัปเดตวันที่ "อัปเดตล่าสุด" การเปลี่ยนแปลงที่สำคัญจะสื่อสารผ่านอีเมลหรือการแจ้งเตือนที่โดดเด่นบนเว็บไซต์ของเรา',
    },

    contact: {
      title: 'ติดต่อเรา',
      description: 'หากคุณมีคำถาม ข้อกังวล หรือคำขอเกี่ยวกับนโยบายความเป็นส่วนตัวนี้หรือการปฏิบัติข้อมูลของเรา โปรดติดต่อเรา:',
      email: 'อีเมล:',
      company: 'บริษัท:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'ข้อกำหนดการใช้บริการ',
    lastUpdated: 'อัปเดตล่าสุด',
    back: 'กลับ',
    viewPrivacyPolicy: 'ดูนโยบายความเป็นส่วนตัว',
    acknowledgment: 'การใช้ Zodiac Chess แสดงว่าคุณรับทราบว่าคุณได้อ่าน เข้าใจ และยอมรับที่จะผูกพันตามข้อกำหนดการใช้บริการเหล่านี้',
    acceptance: {
      title: '1. การยอมรับข้อกำหนด',
      p1: 'การเข้าถึงและใช้ Zodiac Chess ("บริการ") แสดงว่าคุณยอมรับและตกลงที่จะผูกพันตามข้อกำหนดการใช้บริการเหล่านี้ หากคุณไม่ยอมรับข้อกำหนดเหล่านี้ กรุณาอย่าใช้บริการ',
      p2: 'เราขอสงวนสิทธิ์ในการแก้ไขข้อกำหนดเหล่านี้ได้ตลอดเวลา การใช้บริการต่อไปหลังจากมีการเปลี่ยนแปลงถือเป็นการยอมรับข้อกำหนดที่แก้ไขแล้ว',
    },
    description: {
      title: '2. คำอธิบายบริการ',
      p1: 'Zodiac Chess เป็นเกมกระดานกลยุทธ์ออนไลน์ที่มีตัวหมากสัตว์พิเศษพร้อมความสามารถพิเศษ บริการประกอบด้วย:',
      feature1: 'การเล่นคนเดียวกับคู่ต่อสู้ AI',
      feature2: 'การจับคู่ผู้เล่นหลายคนและการแข่งขัน',
      feature3: 'บทเรียนโต้ตอบและแหล่งการเรียนรู้',
      feature4: 'การสร้างบัญชีและการติดตามความก้าวหน้า',
      feature5: 'คุณสมบัติการสมัครสมาชิกพรีเมียมตามต้องการ',
      feature6: 'ตัวเลือกการปรับแต่งรูปลักษณ์',
    },
    accounts: {
      title: '3. บัญชีผู้ใช้',
      eligibility: {
        title: '3.1 คุณสมบัติ',
        p1: 'คุณต้องมีอายุอย่างน้อย 13 ปีเพื่อสร้างบัญชี ผู้ใช้ที่อายุต่ำกว่า 13 ปีสามารถใช้โหมดเล่นในฐานะผู้เยี่ยมชมภายใต้การดูแลของผู้ปกครอง แต่ไม่สามารถสร้างบัญชีได้',
      },
      responsibilities: {
        title: '3.2 ความปลอดภัยของบัญชี',
        p1: 'คุณมีหน้าที่รับผิดชอบสำหรับ:',
        item1: 'การรักษาความลับของรหัสผ่านของคุณ',
        item2: 'กิจกรรมทั้งหมดที่เกิดขึ้นภายใต้บัญชีของคุณ',
        item3: 'การแจ้งให้เราทราบทันทีเกี่ยวกับการใช้งานโดยไม่ได้รับอนุญาต',
        p2: 'เราไม่รับผิดชอบต่อความสูญเสียหรือความเสียหายใดๆ ที่เกิดจากการเข้าถึงบัญชีโดยไม่ได้รับอนุญาต',
      },
      prohibited: {
        title: '3.3 กิจกรรมที่ห้าม',
        p1: 'คุณไม่สามารถ:',
        item1: 'แชร์บัญชีของคุณกับผู้อื่น',
        item2: 'ใช้หลายบัญชีเพื่อบิดเบือนการจัดอันดับ',
        item3: 'ใช้บอท สคริปต์ หรือเครื่องมืออัตโนมัติในการเล่นเกม',
        item4: 'คุกคาม ทำร้าย หรือข่มขู่ผู้เล่นอื่น',
        item5: 'ใช้ประโยชน์จากบั๊กหรือข้อผิดพลาดเพื่อได้เปรียบอย่างไม่เป็นธรรม',
        item6: 'ทำวิศวกรรมย้อนกลับหรือพยายามเข้าถึงซอร์สโค้ดของเรา',
        p2: 'การละเมิดกฎเหล่านี้อาจส่งผลให้บัญชีถูกระงับหรือแบนถาวร',
      },
    },
    premium: {
      title: '4. การสมัครสมาชิกพรีเมียม',
      billing: {
        title: '4.1 การเรียกเก็บเงิน',
        p1: 'การสมัครสมาชิกพรีเมียมดำเนินการผ่าน Stripe เมื่อซื้อการสมัครสมาชิกพรีเมียม คุณอนุญาตให้เราเรียกเก็บเงินจากวิธีการชำระเงินของคุณเป็นประจำจนกว่าคุณจะยกเลิก',
        p2: 'ค่าธรรมเนียมการสมัครสมาชิก:',
        item1: 'แผนรายเดือน: เรียกเก็บเงินรายเดือนในวันครบรอบของวันที่ซื้อ',
        item2: 'แผนรายปี: เรียกเก็บเงินรายปีในวันครบรอบของวันที่ซื้อ',
        p3: 'ราคาอาจเปลี่ยนแปลงโดยแจ้งล่วงหน้า 30 วันให้กับสมาชิกที่ใช้งานอยู่',
      },
      cancellation: {
        title: '4.2 การยกเลิก',
        p1: 'คุณสามารถยกเลิกการสมัครสมาชิกได้ตลอดเวลาผ่านการตั้งค่าบัญชีของคุณหรือโดยการติดต่อฝ่ายสนับสนุน การยกเลิกจะมีผลเมื่อสิ้นสุดรอบบิลปัจจุบันของคุณ',
        p2: 'คุณจะยังคงใช้คุณสมบัติพรีเมียมได้จนถึงสิ้นสุดช่วงเวลาที่ชำระเงินแล้ว แม้หลังจากยกเลิก',
      },
      refunds: {
        title: '4.3 การคืนเงิน',
        p1: 'การสมัครสมาชิกรายเดือน: ไม่มีการคืนเงินสำหรับเดือนที่ไม่เต็ม ยกเลิกได้ตลอดเวลาเพื่อหยุดการเรียกเก็บเงินในอนาคต',
        p2: 'การสมัครสมาชิกรายปี: คืนเงินเต็มจำนวนหากร้องขอภายใน 7 วันหลังการซื้อ หลังจาก 7 วัน การคืนเงินขึ้นอยู่กับดุลยพินิจของเรา',
        p3: 'การซื้อเครื่องสำอาง: โดยทั่วไปไม่สามารถคืนเงินได้ ติดต่อฝ่ายสนับสนุนสำหรับกรณีพิเศษ',
      },
    },
    acceptable: {
      title: '5. นโยบายการใช้งานที่ยอมรับได้',
      p1: 'คุณตกลงที่จะใช้ Zodiac Chess อย่างมีเกียรติและถูกกฎหมาย พฤติกรรมที่ห้ามรวมถึง:',
      item1: 'การโกง การแฮ็ก หรือการใช้ประโยชน์จากกลไกของเกม',
      item2: 'การคุกคาม การพูดจาสร้างความเกลียดชัง หรือภาษาเลือกปฏิบัติ',
      item3: 'การสแปม การโฆษณา หรือการชักชวน',
      item4: 'การแชร์เนื้อหาที่ไม่เหมาะสม (หากเปิดใช้งานแชทหรือเนื้อหาที่สร้างโดยผู้ใช้)',
      item5: 'การแอบอ้างเป็นผู้ใช้อื่นหรือเจ้าหน้าที่',
      item6: 'การพยายามขัดขวางหรือทำลายบริการ',
      p2: 'เราขอสงวนสิทธิ์ในการสอบสวนการละเมิดและดำเนินการที่เหมาะสม รวมถึงการยุติบัญชีและการรายงานต่อเจ้าหน้าที่หากจำเป็น',
    },
    intellectual: {
      title: '6. สิทธิ์ในทรัพย์สินทางปัญญา',
      ownership: {
        title: '6.1 เนื้อหาของเรา',
        p1: 'เนื้อหาเกมทั้งหมด รวมถึงแต่ไม่จำกัดเพียงกลไกของเกม งานศิลปะ แอนิเมชัน เอฟเฟกต์เสียง โค้ด และการออกแบบ เป็นของ Animal Chess Limited หรือผู้ให้ลิขสิทธิ์ของเรา',
        p2: 'คุณได้รับสิทธิ์อนุญาตแบบจำกัด ไม่ผูกขาด และไม่สามารถโอนได้ในการใช้บริการเพื่อวัตถุประสงค์ด้านความบันเทิงส่วนบุคคลเท่านั้น',
      },
      userContent: {
        title: '6.2 เนื้อหาของผู้ใช้',
        p1: 'การส่งเนื้อหา (เช่น ข้อความแชท ชื่อผู้ใช้ หรือข้อมูลโปรไฟล์) แสดงว่าคุณให้สิทธิ์อนุญาตทั่วโลกแบบไม่มีค่าลิขสิทธิ์แก่เราในการใช้ แสดง และแจกจ่ายเนื้อหานั้นที่เกี่ยวข้องกับบริการ',
        p2: 'คุณรับรองว่าคุณเป็นเจ้าของหรือมีสิทธิ์ที่จำเป็นในเนื้อหาใดๆ ที่คุณส่ง',
      },
    },
    disclaimers: {
      title: '7. ข้อจำกัดความรับผิดชอบและการจำกัดความรับผิด',
      p1: 'บริการนี้จัดให้ "ตามสภาพ" โดยไม่มีการรับประกันใดๆ ไม่ว่าโดยชัดแจ้งหรือโดยนัย',
      p2: 'เราไม่รับประกันว่า:',
      item1: 'บริการจะทำงานอย่างต่อเนื่องหรือปราศจากข้อผิดพลาด',
      item2: 'ข้อบกพร่องจะได้รับการแก้ไข',
      item3: 'บริการปราศจากไวรัสหรือส่วนประกอบที่เป็นอันตราย',
      item4: 'ผลลัพธ์จากการใช้บริการจะตรงตามความคาดหวังของคุณ',
      p3: 'ในขอบเขตสูงสุดที่กฎหมายอนุญาต เราจะไม่รับผิดชอบสำหรับ:',
      item5: 'ความเสียหายทางอ้อม โดยบังเอิญ หรือผลที่ตามมา',
      item6: 'การสูญเสียกำไร ข้อมูล หรือชื่อเสียง',
      item7: 'การหยุดชะงักของบริการหรือการสูญเสียข้อมูล',
      item8: 'ความเสียหายที่เกินกว่าจำนวนเงินที่คุณจ่ายให้เราในช่วง 12 เดือนที่ผ่านมา',
    },
    privacy: {
      title: '8. ความเป็นส่วนตัว',
      p1: 'การใช้บริการของคุณยังอยู่ภายใต้นโยบายความเป็นส่วนตัวของเรา ซึ่งอธิบายวิธีที่เราเก็บรวบรวม ใช้ และปกป้องข้อมูลส่วนบุคคลของคุณ',
      p2: 'การใช้บริการแสดงว่าคุณยินยอมให้เราดำเนินการกับข้อมูลตามที่อธิบายไว้ในนโยบายความเป็นส่วนตัว',
    },
    changes: {
      title: '9. การเปลี่ยนแปลงข้อกำหนด',
      p1: 'เราขอสงวนสิทธิ์ในการแก้ไขข้อกำหนดการใช้บริการเหล่านี้ได้ตลอดเวลา เราจะแจ้งให้ผู้ใช้ทราบเกี่ยวกับการเปลี่ยนแปลงที่สำคัญผ่าน:',
      item1: 'การแจ้งเตือนทางอีเมลไปยังผู้ใช้ที่ลงทะเบียน',
      item2: 'ประกาศที่โดดเด่นบนเว็บไซต์',
      item3: 'วันที่ "อัปเดตล่าสุด" ที่อัปเดตแล้วที่ด้านบนของหน้านี้',
      p2: 'การใช้บริการต่อไปหลังจากมีการเปลี่ยนแปลงถือเป็นการยอมรับข้อกำหนดที่แก้ไขแล้ว',
    },
    governing: {
      title: '10. กฎหมายที่ใช้บังคับ',
      p1: 'ข้อกำหนดการใช้บริการเหล่านี้อยู่ภายใต้กฎหมายของนิวซีแลนด์ โดยไม่คำนึงถึงหลักการขัดแย้งของกฎหมาย',
      p2: 'ข้อพิพาทใดๆ ที่เกิดขึ้นจากข้อกำหนดเหล่านี้หรือการใช้บริการของคุณจะได้รับการแก้ไขในศาลของนิวซีแลนด์',
    },
    contact: {
      title: '11. ข้อมูลการติดต่อ',
      p1: 'สำหรับคำถาม ข้อกังวล หรือการสนับสนุนเกี่ยวกับข้อกำหนดการใช้บริการเหล่านี้:',
      email: 'อีเมล:',
      company: 'บริษัท:',
      address: 'ที่อยู่:',
    },
    severability: {
      title: '12. การแยกส่วน',
      p1: 'หากข้อกำหนดใดๆ ในข้อกำหนดเหล่านี้ถูกพบว่าไม่สามารถบังคับใช้ได้หรือไม่ถูกต้อง ข้อกำหนดนั้นจะถูกจำกัดหรือยกเลิกในขอบเขตที่จำเป็นน้อยที่สุด และข้อกำหนดที่เหลือจะยังคงมีผลบังคับใช้อย่างเต็มที่',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'นโยบายคุกกี้',
    lastUpdated: 'อัปเดตล่าสุด',
    browserInstructions: {
      chrome: 'การตั้งค่า → ความเป็นส่วนตัวและความปลอดภัย → คุกกี้',
      firefox: 'การตั้งค่า → ความเป็นส่วนตัวและความปลอดภัย → คุกกี้และข้อมูลไซต์',
      safari: 'การตั้งค่า → ความเป็นส่วนตัว → คุกกี้และข้อมูลเว็บไซต์',
      edge: 'การตั้งค่า → ความเป็นส่วนตัว การค้นหา และบริการ → คุกกี้',
    },
    cookieTable: {
      name: 'ชื่อคุกกี้',
      purpose: 'วัตถุประสงค์',
      duration: 'ระยะเวลา',
      type: 'ประเภท',
    },
    relatedPolicies: {
      title: 'นโยบายที่เกี่ยวข้อง',
      description: 'สำหรับข้อมูลเพิ่มเติมเกี่ยวกับวิธีที่เราจัดการข้อมูลของคุณ โปรดดู:',
      privacy: 'นโยบายความเป็นส่วนตัว',
      terms: 'ข้อกำหนดการใช้บริการ',
    },

    introduction: {
      title: 'บทนำ',
      p1: 'นโยบายคุกกี้นี้อธิบายวิธีที่ Zodiac Chess ("เรา" หรือ "พวกเรา") ใช้คุกกี้และเทคโนโลยีที่คล้ายกันเมื่อคุณเยี่ยมชมเว็บไซต์ของเรา',
      p2: 'การใช้เว็บไซต์ของเราแสดงว่าคุณยินยอมให้เราใช้คุกกี้ตามนโยบายนี้ หากคุณไม่เห็นด้วย โปรดปิดใช้งานคุกกี้ในการตั้งค่าเบราว์เซอร์ของคุณหรือไม่ใช้เว็บไซต์ของเรา',
    },
    what: {
      title: 'คุกกี้คืออะไร?',
      p1: 'คุกกี้คือไฟล์ข้อความขนาดเล็กที่ถูกวางบนอุปกรณ์ของคุณ (คอมพิวเตอร์ สมาร์ทโฟน แท็บเล็ต) เมื่อคุณเยี่ยมชมเว็บไซต์ ใช้กันอย่างแพร่หลายเพื่อทำให้เว็บไซต์ทำงานอย่างมีประสิทธิภาพและให้ข้อมูลแก่เจ้าของเว็บไซต์',
      p2: 'คุกกี้มีวัตถุประสงค์หลายอย่าง รวมถึงการจดจำการตั้งค่าของคุณ การวิเคราะห์การใช้งานไซต์ และการเปิดใช้งานคุณสมบัติบางอย่าง',
    },
    types: {
      title: 'ประเภทของคุกกี้ที่เราใช้',
      necessary: {
        title: '1. คุกกี้ที่จำเป็น',
        description: 'คุกกี้เหล่านี้จำเป็นสำหรับการทำงานที่ถูกต้องของเว็บไซต์ หากไม่มีคุกกี้เหล่านี้ บริการที่คุณร้องขอจะไม่สามารถให้บริการได้',
        examples: 'ตัวอย่าง:',
        item1: 'คุกกี้การยืนยันตัวตน - รักษาสถานะการเข้าสู่ระบบบัญชีของคุณ',
        item2: 'คุกกี้ความปลอดภัย - ป้องกันกิจกรรมฉ้อโกง',
        item3: 'คุกกี้เซสชัน - รักษาสถานะเกมของคุณระหว่างเซสชัน',
        item4: 'การตั้งค่าความยินยอมคุกกี้ - จดจำตัวเลือกคุกกี้ของคุณ',
      },
      analytics: {
        title: '2. คุกกี้วิเคราะห์',
        description: 'คุกกี้เหล่านี้ช่วยให้เราเข้าใจว่าผู้เยี่ยมชมมีปฏิสัมพันธ์กับเว็บไซต์ของเราอย่างไรโดยการเก็บรวบรวมข้อมูลที่ไม่ระบุตัวตนเกี่ยวกับการเยี่ยมชมหน้า เวลาที่ใช้ และคุณสมบัติที่ใช้',
        provider: 'ผู้ให้บริการ: Firebase Analytics (Google)',
        purpose: 'วัตถุประสงค์:',
        item1: 'วัดการเข้าชมเว็บไซต์และการมีส่วนร่วมของผู้ใช้',
        item2: 'ระบุคุณสมบัติและหน้าที่เป็นที่นิยม',
        item3: 'เข้าใจข้อมูลประชากรของผู้ใช้ (ช่วงอายุ ตำแหน่งที่ตั้งทั่วไป)',
        item4: 'ปรับปรุงประสิทธิภาพเว็บไซต์และประสบการณ์ผู้ใช้',
      },
      advertising: {
        title: '3. คุกกี้โฆษณา',
        description: 'คุกกี้เหล่านี้ใช้เพื่อแสดงโฆษณาที่เกี่ยวข้องกับคุณ ยังจำกัดจำนวนครั้งที่คุณเห็นโฆษณาและช่วยวัดประสิทธิภาพของแคมเปญโฆษณา',
        provider: 'ผู้ให้บริการ: Google AdSense',
        purpose: 'วัตถุประสงค์:',
        item1: 'แสดงโฆษณาที่ปรับให้เหมาะกับความสนใจของคุณ',
        item2: 'วัดประสิทธิภาพและการมีส่วนร่วมของโฆษณา',
        item3: 'ป้องกันการแสดงโฆษณาเดียวกันบ่อยเกินไป',
        note: 'หมายเหตุ: สมาชิกพรีเมียมจะไม่เห็นโฆษณาใดๆ ไม่ว่าจะตั้งค่าคุกกี้อย่างไร',
      },
    },
    firstThird: {
      title: 'คุกกี้ของบุคคลที่หนึ่ง vs คุกกี้ของบุคคลที่สาม',
      firstParty: {
        title: 'คุกกี้ของบุคคลที่หนึ่ง',
        description: 'เหล่านี้คือคุกกี้ที่ตั้งค่าโดยตรงจาก Zodiac Chess เราใช้สำหรับฟังก์ชันเว็บไซต์ที่จำเป็น การยืนยันตัวตน และการจดจำการตั้งค่าของคุณ',
      },
      thirdParty: {
        title: 'คุกกี้ของบุคคลที่สาม',
        description: 'เหล่านี้คือคุกกี้ที่ตั้งค่าโดยบริการภายนอกที่เราใช้ เช่น Google Analytics และ Google AdSense คุกกี้ของบุคคลที่สามอยู่ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการเหล่านั้น',
      },
    },
    specific: {
      title: 'คุกกี้เฉพาะที่เราใช้',
      tableHeader: 'ด้านล่างนี้คือรายการโดยละเอียดของคุกกี้ที่ใช้บนเว็บไซต์ของเรา:',
    },
    control: {
      title: 'วิธีควบคุมคุกกี้',
      consent: {
        title: '1. แบนเนอร์ความยินยอมคุกกี้',
        description: 'เมื่อคุณเยี่ยมชมเว็บไซต์ของเราครั้งแรก คุณจะเห็นแบนเนอร์ความยินยอมคุกกี้ คุณสามารถ:',
        item1: 'ยอมรับทั้งหมด - อนุญาตคุกกี้ทั้งหมด (จำเป็น วิเคราะห์ และโฆษณา)',
        item2: 'ปฏิเสธทางเลือก - อนุญาตเฉพาะคุกกี้ที่จำเป็น (ไม่มีการวิเคราะห์หรือโฆษณา)',
        item3: 'ปรับแต่ง - เลือกประเภทคุกกี้ที่คุณต้องการอนุญาตอย่างแม่นยำ',
      },
      browser: {
        title: '2. การตั้งค่าเบราว์เซอร์',
        description: 'เว็บเบราว์เซอร์ส่วนใหญ่อนุญาตให้คุณควบคุมคุกกี้ผ่านการตั้งค่า คุณสามารถ:',
        item1: 'บล็อกคุกกี้ทั้งหมด',
        item2: 'ยอมรับเฉพาะคุกกี้ของบุคคลที่หนึ่ง',
        item3: 'ลบคุกกี้หลังจากแต่ละเซสชันการท่องเว็บ',
        item4: 'ดูและลบคุกกี้แต่ละรายการ',
        links: 'นี่คือลิงก์ไปยังการจัดการคุกกี้สำหรับเบราว์เซอร์ยอดนิยม:',
      },
      optOut: {
        title: '3. เครื่องมือยกเลิก',
        description: 'สำหรับคุกกี้โฆษณาโดยเฉพาะ คุณสามารถเลือกยกเลิกโฆษณาที่ปรับให้เหมาะกับคุณ:',
        googleLink: 'การตั้งค่าโฆษณา Google',
        googleDesc: ' - จัดการโฆษณาที่ปรับให้เหมาะกับคุณของ Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - ยกเลิกโฆษณาตามความสนใจ',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - เครื่องมือยกเลิกเฉพาะ EU',
      },
    },
    impact: {
      title: 'ผลกระทบของการปิดใช้งานคุกกี้',
      p1: 'หากคุณปิดใช้งานหรือปฏิเสธคุกกี้ โปรดทราบว่า:',
      item1: 'บางส่วนของเว็บไซต์อาจทำงานไม่ถูกต้อง',
      item2: 'คุณอาจต้องป้อนการตั้งค่าของคุณใหม่ในแต่ละครั้งที่เยี่ยมชม',
      item3: 'คุณอาจถูกออกจากระบบบัญชีของคุณ',
      item4: 'คุกกี้ที่จำเป็นต้องมีเพื่อให้เว็บไซต์ทำงาน - การปิดใช้งานจะป้องกันไม่ให้คุณใช้คุณสมบัติหลัก',
    },
    updates: {
      title: 'การอัปเดตนโยบายคุกกี้นี้',
      p1: 'เราอาจอัปเดตนโยบายคุกกี้นี้เป็นครั้งคราวเพื่อสะท้อนการเปลี่ยนแปลงในแนวปฏิบัติของเราหรือด้วยเหตุผลทางกฎหมาย ข้อบังคับ หรือการดำเนินงาน',
      p2: 'เราจะแจ้งให้คุณทราบเกี่ยวกับการเปลี่ยนแปลงที่สำคัญโดยการอัปเดตวันที่ "อัปเดตล่าสุด" ที่ด้านบนของหน้านี้ โปรดตรวจสอบนโยบายนี้เป็นระยะ',
    },
    contact: {
      title: 'ติดต่อเรา',
      p1: 'หากคุณมีคำถามเกี่ยวกับการใช้คุกกี้ของเราหรือนโยบายคุกกี้นี้ โปรดติดต่อเรา:',
      email: 'อีเมล:',
      company: 'บริษัท:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'เพนกวิน',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'หมี',
    Crane: 'นกกระเรียน',
    Frog: 'กบ',
    Fungi: 'เห็ด',
    Goat: 'แพะ',
    Monkey: 'ลิง',
    Octopus: 'ปลาหมึกยักษ์',
    Penguin: 'เพนกวิน',
    Rhino: 'แรด',
    Snake: 'งู',
    Tree: 'ต้นไม้',
    Virus: 'ไวรัส',
    Wolf: 'หมาป่า',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
